import { Color } from 'client/Global/Colors'
import { l } from 'client/Other/Translation'
import React from 'react'
import { CirclePicker, CustomPicker } from 'react-color'

const { EditableInput } = require('react-color/lib/components/common')

export const colors = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffc107',
  '#ff9800',
  '#ff5722',
  '#795548',
  '#607d8b',
  '#333',
]

const ColorPicker = ({ color, onChange }) => {
  return (
    <div className="ColorContainer">
      <div className="InnerColorBox">
        <div className="ColorBox">
          <h4>{l('customTemplates.colorPicker.default')}</h4>
          <CirclePicker circleSize={20} colors={colors} onChange={onChange} width={'220px'} />
        </div>
        <hr />
        <div className="ColorBox">
          <h4>{l('customTemplates.colorPicker.hex')}</h4>
          <EditableInput value={color} onChange={onChange} />
        </div>
      </div>
    </div>
  )
}

export default CustomPicker(ColorPicker)
